import {useEffect, useState} from "react";
import type {EBirdChecklistByFamily} from "ebird-mydata-reader";

export function useChecklistReference(shouldLoad: boolean) {
    const [checklistReference, setChecklistReference] = useState<EBirdChecklistByFamily[]>([]);
    const [isChecklistReferenceLoading, setIsChecklistReferenceLoading] = useState(false);

    useEffect(() => {
        let isActive = true;

        const loadChecklistReference = async () => {
            if (!shouldLoad) {
                setIsChecklistReferenceLoading(false);
                return;
            }

            if (checklistReference.length) {
                setIsChecklistReferenceLoading(false);
                return;
            }

            setIsChecklistReferenceLoading(true);

            try {
                const module = await import('../assets/data/checklist-with-images.json');
                if (!isActive) return;

                const nextChecklistReference = (module.default ?? module) as unknown as EBirdChecklistByFamily[];
                setChecklistReference(nextChecklistReference);
            } catch (error) {
                console.error(error);
                if (!isActive) return;

                setChecklistReference([]);
            } finally {
                if (!isActive) return;
                setIsChecklistReferenceLoading(false);
            }
        };

        void loadChecklistReference();

        return () => {
            isActive = false;
        };
    }, [checklistReference.length, shouldLoad]);

    return {
        checklistReference,
        isChecklistReferenceLoading
    };
}

